































import { Configuration, DataTableAction, UpdateConfigurationPayload } from '@/utils/types'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Action, Getter } from 'vuex-class'
import DataTable from '../../components/DataTable.vue'
import { DataTableHeader } from 'vuetify'
import ConfigurationCrud from '../../components/ConfigurationCrud.vue'

@Component({
  components: { DataTable, ConfigurationCrud }
})
export default class Configurations extends Vue {
  @Action fetchConfigurations!: () => Promise<void>;

  @Action updateConfiguration!: (
    payload: UpdateConfigurationPayload
  ) => Promise<boolean>;

  @Getter configurations!: Configuration[]

  isDialogOpen = false;
  selectedConfiguration: Configuration | null = null
  configurationHeaders: DataTableHeader[] = [
    { text: 'הגדרה', value: 'hebrewKey' },
    { text: 'ערך', value: 'value' }];

  async mounted () {
    await this.fetchConfigurations()
  }

  get configurationActions (): DataTableAction<Configuration>[] {
    return [
      {
        text: 'עריכה',
        icon: 'mdi-pencil',
        handler: (configuration) => this.openCrudDialog(configuration)
      }
    ]
  }

  get formattedConfigurations () {
    return this.configurations.map((conf) => ({
      ...conf,
      hebrewKey: this.translateConfig(conf.key)
    }))
  }

  get valueType () {
    if (this.selectedConfiguration) {
      const configKey = this.configurations.find(c => c.id === this.selectedConfiguration?.id)?.key
      if (!configKey) {
        return
      }
      if (configKey.includes('WAGE')) {
        return 'number'
      }
    }
    return 'text'
  }

  async handleSubmit (configuration: Configuration) {
    await this.updateConfiguration(configuration)
    this.closeCrudDialog()
  }

  openCrudDialog (configuration: Configuration | null = null) {
    this.selectedConfiguration = configuration
    this.isDialogOpen = true
  }

  closeCrudDialog () {
    this.isDialogOpen = false
    this.selectedConfiguration = null
  }

  translateConfig (key: string) {
    if (key.startsWith('MINIMUM_WAGE_')) {
      return 'שכר מינימום לגיל' + key.replace('MINIMUM_WAGE_', ' ')
    }
    if (key.startsWith('AVERAGE_WAGE_')) {
      return 'שכר ממוצע לגיל' + key.replace('AVERAGE_WAGE_', ' ')
    }
    if (key === 'SUPPORT_EMAIL') {
      return 'אימייל לתמיכה טכנית'
    }
    if (key === 'EMPLOYER_SUPPORT_EMAIL') {
      return 'אימייל לתמיכה למעסיקים'
    }
    return key
  }
}
